var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.659 12 7-7-1.415-1.414-7 7-7-7L3.83 5l7 7-7 7 1.414 1.414 7-7 7 7L20.66 19l-7-7Z",
    fill: "currentColor"
  })));
};
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "d5e6d2efcd0cf73f29f1765a627dee61.svg";